import env from 'app/env';
import { setupServer as setupAbiskoServer } from '@svt/abtest/server';

const error = require('debug')('play:server:abisko:error');
const debug = require('debug')('play:server:abisko:debug');

let setupAbisko;

if (env.FLAG_ENABLE_ABISKO) {
    setupAbisko = (store, req) =>
        setupAbiskoServer({
            projectId: 'svtplay',
            environment: env.ABISKO_ENVIRONMENT,
            reduxStore: store,
            showDebugInfo: env.IS_DEVELOPMENT,
            networkTimeout: env.ABISKO_SERVER_TIMEOUT,
            platform: 'web',
            // experimentsConfig: {
            //     // Configuration object for specific experiment overrides
            //     [experimentid]: {
            //         ignoreNewUsers: true, // If true: Will ignore tests if user has no allocations stored in cookie but will allocate on client
            //     },
            // },
            cookies: {
                'svt-abisko-svtplay-experiments':
                    req.cookies['svt-abisko-svtplay-experiments'] || '',
            },
        })
            .then(({ projectId, activeExperiments, activeAllocations }) => {
                debug('setupAbiskoServer', {
                    projectId,
                    activeExperiments,
                    activeAllocations,
                });
            })
            .catch((e) => {
                error('Got an error from a/bisko', e);
            });
} else {
    setupAbisko = (store, req) => Promise.resolve();
}

export default setupAbisko;
